// extracted by mini-css-extract-plugin
export default {"topSection":"TopSection_topSection__zvYZP","topContentBox":"TopSection_topContentBox__1jvWv"};